export default __webpack_public_path__ + "static/media/4151017.223edefc.jpg";